// extracted by mini-css-extract-plugin
export default {"p":"Sms-p"};